import Attributes from './attributes.container';

export default Attributes;
